import axios from "axios";


const baseURL = process.env.VUE_APP_API_BASE_URL || "https://api.cocacola.tasks.autos/api/";
// const baseURL = "http://192.168.1.35:8000/api/";
// const baseURL = "http://localhost:8000/api/";

const apiClient = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});


export default apiClient;